<template>
  <div class="scenario_common_params">
    <div class="field">
      <label class="label">{{$t('common.title')}}</label>
      <div class="control">
        <input class="input" type="text" v-bind:placeholder="$t('scenarios.scenarioName')" v-model="name" v-on:change="scenarioNameChange()">
      </div>
    </div>

    <div class="field">
      <div class="control">
        <label class="checkbox">
          <input type="checkbox" v-model="hideArrowsVar" v-on:change="hideArrowsChange()">
          {{$t('scenarios.konstruktor.commonParams.hideArrows')}}
        </label>
      </div>
    </div>

    <div class="commonParameters">

      <div class="field is-horizontal locale">
        <div class="field-label is-normal"><label class="label">{{$t('common.language')}}</label></div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <div  v-if="googleLanguages" class="select langSelect">
                <select v-model="lang" class="form-control lang scenarioLang" v-on:change="localeChange()">
                  <option v-for="language in googleLanguages" :value="language.value">
                    {{language.label}}
                  </option>
                </select>
              </div>
              <input v-else class="input scenarioLang" type="text" placeholder="Locale" v-model="locale" v-on:change="localeChange()"/>
            </div>
          </div>
        </div>
      </div>


      <div class="field is-horizontal locale">
        <div class="field-label is-normal"><label class="label">{{$t('scenarios.konstruktor.canvas.recognition.recognitionDriver')}}</label></div>
        <div class="field-body">
          <div class="field">
            <div class="select">
              <select v-model="driver" class="form-control vendor" v-on:change="recognitionDriverChange()">
                <option value="google">Google</option>
                <option value="yandex">Yandex</option>
              </select>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import {googleLanguages as importedGoogleLanguages} from './googleVoices'

  export default {
        props: ['hideArrows', 'scenarioName', 'locale', 'recognitionDriver'],
        methods: {
            scenarioNameChange() {
                this.$emit('scenarioNameChange', this.name)
            },
            hideArrowsChange() {
                this.$emit('hideArrowsChange', this.hideArrowsVar)
            },
            localeChange() {
              this.$emit('localeChange', this.lang)
            },
            recognitionDriverChange() {
              this.$emit('recognitionDriverChange', this.driver)
            }
        },
        created() {
            console.log(this._props.hideArrows)
            this.name = this._props.scenarioName
            this.lang = this._props.locale + ''
            this.driver = this._props.recognitionDriver
            this.hideArrowsVar = this._props.hideArrows
        },
        data() {
          return {
            name: '',
            hideArrowsVar: '',
            googleLanguages: importedGoogleLanguages,
            lang: '',
            driver: ''
          }
        }
    }
</script>

<style scoped>

  .field {
    margin-top:10px;
    margin-bottom: 10px;
  }

  .lang, .langSelect {
    max-width: 100%;
  }

</style>



// WEBPACK FOOTER //
// ScenarioCommonParams.vue?317dc228